module.exports = __webpack_public_path__ + "img/success-green.17d88e28.png";